/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UpdateInvestmentHoldingRequest} from '@cash-web/protos/squareup/franklin/investing.pb'
import {UpdateInvestmentHoldingResponse} from '@cash-web/protos/squareup/franklin/investing.pb'


export const updateInvestmentHolding = (request:UpdateInvestmentHoldingRequest, options?: CashRequestOptions) => post<UpdateInvestmentHoldingRequest, UpdateInvestmentHoldingResponse>("/2.0/cash/update-investment-holding", request, {...options, rejectOnError: true })